let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jhKC9")).then(() => parcelRequire('jXmR0'));